import { post } from "../../network/endpoint";
import { success } from "services/utils/action";
import * as ActionTypes from "services/state/action-types";
import { SENSEDIA_CORP } from "../../network/routes";

export function repeatRequest(request) {
  return (dispatch) =>
    dispatch({
      type: ActionTypes.SENSEDIA_CORP_REPEAT_REQUEST,
      payload: { request, client: SENSEDIA_CORP },
    }).then(
      success(({ payload }) => {
        return request.resolve(payload);
      })
    );
}

export function requestAccessTokenCorp(code, callBack) {
  return (dispatch) => {
    const data = {
      grant_type: "authorization_code",
      code,
    };
    const config = { data, client: SENSEDIA_CORP };
    const request = post("accessTokenCorp", config);
    return dispatch({
      type: ActionTypes.SENSEDIA_CORP_ACCESS_CODE,
      payload: request,
    }).then(
      success(({ payload: { data } }) => {
        const { access_token } = data;
        if (access_token) {
          return dispatch(repeatRequest(callBack));
        }
      })
    );
  };
}

export function requestGrantCode(callback) {
  return (dispatch) => {
    const data = {
      client_id: "247471e4-054e-3597-acf0-b5fb250e36c3",
      extraInfo: {},
      redirect_uri: "http://b2b-sensedia-sandbox",
    };
    const config = { data, client: SENSEDIA_CORP };
    const request = post("grantCode", config);
    return dispatch({
      type: ActionTypes.SENSEDIA_CORP_GRANT_CODE,
      payload: request,
    }).then(
      success(({ payload: { data } }) => {
        const { redirect_uri } = data;
        if (!redirect_uri) {
          return null;
        }
        const params = redirect_uri.split("code=");
        const grantCode = params.length > 1 ? params[1] : "";
        return dispatch(requestAccessTokenCorp(grantCode, callback));
      })
    );
  };
}

export function refreshAccessTokenCorp(code, callBack) {
  return (dispatch) => {
    const data = {
      grant_type: "refresh_token",
      refresh_token: code,
    };
    const config = { data, client: SENSEDIA_CORP };
    const request = post("accessTokenCorp", config);
    return dispatch({
      type: ActionTypes.SENSEDIA_CORP_GRANT_CODE,
      payload: request,
    }).then(
      success(({ payload: { data } }) => {
        const { access_token } = data;
        if (access_token) {
          return dispatch(repeatRequest(callBack));
        }
      })
    );
  };
}

export function setAccessTokenCorp(request) {
  return (dispatch) =>
    dispatch({
      type: ActionTypes.SENSEDIA_CORP_ACCESS_TOKEN,
      payload: request,
    });
}



// WEBPACK FOOTER //
// ./src/services/state/sensediaCorp/action.js